function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: -0.000488281,
  y: 0.287048,
  width: 35.0005,
  height: 35.4213,
  rx: 3,
  fill: "#201D2F",
  fillOpacity: 1
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27 12.4315C24.8307 12.4315 22.9849 11.2552 22.1914 10.55C22.1061 10.4742 21.9753 10.4781 21.8944 10.5585C21.1835 11.2646 19.5106 12.4315 17.4401 12.4315C15.3005 12.4315 13.4797 11.2581 12.6945 10.5526C12.6089 10.4757 12.4768 10.4797 12.3956 10.5612C11.6921 11.2676 10.0417 12.4315 7.99963 12.4315",
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27 16.4796C24.8307 16.4796 22.9849 15.3033 22.1914 14.5981C22.1061 14.5223 21.9753 14.5263 21.8944 14.6067C21.1835 15.3128 19.5106 16.4796 17.4401 16.4796C15.3005 16.4796 13.4797 15.3062 12.6945 14.6007C12.6089 14.5238 12.4768 14.5278 12.3956 14.6094C11.6921 15.3158 10.0417 16.4796 7.99963 16.4796",
  stroke: "#F0F0F5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9998 22.5929L17.2399 28.9081L23.4801 22.5929L22.4402 21.5398L17.2399 26.8033L12.0397 21.5398L10.9998 22.5929Z",
  fill: "#F0F0F5"
});

function SvgBelow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelow);
export default __webpack_public_path__ + "static/media/below.8a97ce8a.svg";
export { ForwardRef as ReactComponent };